import { type TAny } from '@flatbiz/utils';
import { Fragment } from 'react';
import { useIframe } from './hooks';

export const IframeMainRegister = () => {
  const iframeApi = useIframe((data: TAny) => {
    if (data.type === '__refresh-iframe-tab') {
      iframeApi.broadcastMessages({
        type: data.type,
        data: data.data,
      });
    }
  });

  return <Fragment />;
};
